export const newzealand = {
    slug: "newzealand",
    name: "New Zealand",
    flag: "🇳🇿",
    tagline: "Study in Nature, Graduate for the World",
    heroImg: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1600&auto=format&fit=crop",
    accentColor: "#003C7D",
    students: "40+",
    avgTuition: "NZ$22,000–$38,000/yr",
    avgLiving: "NZ$1,200–$1,800/mo",
    workPermit: "Up to 3 years",
    ieltsReq: "6.0–6.5",
    intakeMonths: ["February", "July"],
    overview: "New Zealand combines globally recognised education, excellent safety, practical learning, and generous post-study work rights.",
    whyChoose: [
        { icon: "🎓", title: "Globally Recognised Degrees", desc: "All universities rank internationally." },
        { icon: "🌿", title: "High Quality Life", desc: "Safe, clean, peaceful country with nature-rich lifestyle." },
        { icon: "💼", title: "Work While Studying", desc: "Part-time work options for students." },
        { icon: "📋", title: "Up to 3-Year Permit", desc: "Strong post-study work opportunities." },
        { icon: "🩺", title: "Skill Shortages", desc: "Demand in healthcare, IT, construction, engineering." },
        { icon: "🤝", title: "PR Pathways", desc: "Migration routes for skilled graduates." },
    ],
    process: [
        { step: "01", title: "Choose Institution", desc: "Select university or institute." },
        { step: "02", title: "Apply", desc: "Submit academic and language documents." },
        { step: "03", title: "Student Visa", desc: "Show funds and receive visa approval." },
        { step: "04", title: "Arrive", desc: "Begin studies and orientation." },
    ],
    universities: ["auckland", "otago", "waikato", "massey", "victoria-wellington", "canterbury", "lincoln", "aut"],
    stats: [{ n: "40+", label: "Students Placed" }, { n: "NZ$22k", label: "Min Tuition/yr" }, { n: "94%", label: "Visa Success" }, { n: "3yr", label: "Post-Study Permit" },],
};